import { action, computed, observable } from 'mobx';
import StoresRepository, { IStoresRepositoryConfig } from '../StoresRepository';
import BopisStoresCollection from '../../domain/entities/Store/BopisStoresCollection';
import BopisFormData from '../../controllers/BopisViewController/BopisFormData';
import Store from '../../domain/entities/Store/Store';

type IBopisStoresRepositoryConfig = IStoresRepositoryConfig;

export default class BopisStoresRepository extends StoresRepository {
  @observable bopisFormData: BopisFormData;

  @observable isBopisSelected: boolean;

  constructor(props: IBopisStoresRepositoryConfig) {
    super(props);

    this.bopisFormData = new BopisFormData(props.config);

    this.storesCollection = new BopisStoresCollection();
  }

  loadStore = async (doorId: string, selectedStore?: Store): Promise<void> => {
    try {
      const { setSelectedStore } = this.bopisStoresCollection;
      if (selectedStore) {
        setSelectedStore(selectedStore);
      } else {
        const response = await this.api.getStoreById(doorId);
        setSelectedStore(Store.fromJSON(response.stores[0]));
      }
      
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };

  loadBobisStore = async (doorId: string): Promise<void> =>{
    if (!doorId) {
      return;
    }
    this.setIsBopisSelected(true);
    // Get selected store if store is not in the list of stores near user's current location.
    const selectedStore = this.bopisStoresCollection.getSelectedStore(doorId);
    return this.loadStore(doorId, selectedStore);
  };

  setBopis = async (): Promise<void> => {
    try {
      await this.api.setBopis(this.bopisFormData.values);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };

  removeBopisInfo = async (): Promise<void> => {
    try {
      await this.api.removeBopis();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };

  @computed
  get bopisStoresCollection(): BopisStoresCollection {
    return this.storesCollection;
  }

  @action
  setIsBopisSelected = (value: boolean): void => {
    this.isBopisSelected = value;
  };
}
